<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">物品领用申请</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <consumable-use ref="create" :userData="userData" :formByFather="form"></consumable-use>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <div class="tip" style="margin-left:120px;">
              <p>* 易耗品领用人请选择申请人所在部门部长</p>
            </div>

            <!-- 审批 -->
            <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom>
            <!-- 审批
            <approval-item ref="approval" :approvalUsers="approvalUsers.c50" :selectArr="selectArr" :approvalSetDep="approvalSetDep"></approval-item> -->


            <!-- <div class="clear">
              <el-form-item>
                <div class="tab-title">
                  <span class="title">默认审批人</span>
                </div>
              </el-form-item>
              <div class="form-item left mx">
                <label> </label>
                <div class="person-room" style="margin-top:0px;" v-for="item,i in defaultApprovalUsers">
                  <span class="persion-item" style="padding:0 15px;background:rgb(156, 44, 230)">
                    {{item.name}}
                  </span>
                </div>
              </div>
            </div> -->

          </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitMaterial()" class="form-btn" type="success">确认提交使用物品申请
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  // import approvalUsers from '@/Mixins/approvalUsers'
  import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import ConsumableUse from '@/page/form/consumable/use'
  export default {
    components: {
      ApprovalItemByCustom,
      ConsumableUse,
      ApprovalItem,
      Attachments,
    },
    // mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          customerId: '',
          depId: '',
          remark: '',
          consumableItems: [],
          remark: "",
          json: true,
        },
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      ajax.get('/user/bz/get', "", res => {
        if (res.vo) {
          this.selectArr.push(res.vo)
        }
      })
      // ajax.post('/user/approval/users/log', {
      //   flowSource: 63,
      //   flowSourceType: '',
      // }, (res) => {
      //   this.selectArr = res.vo.approvals.map(item => item.user)
      // })
    },
    methods: {
      // 提交使用物品申请单
      SubmitMaterial() {
        this.form = this.$refs.create.getFromData()

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = !this.form.applyId ? '/consumable/use' : '/consumable/use/edit?applyId=' + this.form.applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交使用物品申请成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改使用物品申请成功，请耐心等待领导审批")
          }
          this.$router.push('/Consumable/UseList/')
        }, (res) => {
          this.formLoading = false
        })
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/page/consumable/Use.vue